<template>
  <ul class="payment-icons">
    <li
      :arial-label="$string('general.payment_types.american_express')"
    >
      <icon-bluepay />
    </li>
    <li
      :arial-label="$string('general.payment_types.visa')"
    >
      <icon-visa />
    </li>

    <li
      :arial-label="$string('general.payment_types.mastercard')"
    >
      <icon-mastercard />
    </li>

    <li
      :arial-label="$string('general.payment_types.cash_on_delivery')"
    >
      <icon-cashondelivery />
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Payment icons (payment-icons)
 * -----------------------------------------------------------------------------
 * Payment Icons.
 *
 */
import IconMastercard from '~icons/payment/mastercard.svg'
import IconCashondelivery from '~icons/payment/cashondelivery.svg'
import IconVisa from '~icons/payment/visa.svg'
import IconBluepay from '~icons/payment/bluepay.svg'

export default {
  name: 'PaymentIcons',

  components: {
    IconMastercard,
    IconCashondelivery,
    IconVisa,
    IconBluepay,
  },

  data() {
    return {
      global: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './payment-icons';
</style>